module.exports = __webpack_public_path__ + "man.png?dcd142e8d459b109619617721f2fb126";